import { render, staticRenderFns } from "./CoozzyListItem.vue?vue&type=template&id=cfaf2d36&scoped=true"
import script from "./CoozzyListItem.vue?vue&type=script&lang=js"
export * from "./CoozzyListItem.vue?vue&type=script&lang=js"
import style0 from "./CoozzyListItem.vue?vue&type=style&index=0&id=cfaf2d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf2d36",
  null
  
)

export default component.exports